export const CHAT_SESSION_ID = 'chat_session_id';

export const SPLIT_BILLS_QUERY_PARAMS = {
  GROUP_ID: 'groupId',
  GROUP_NAME: 'groupName',
  INVITER_NAME: 'inviterName',
  SPLIT_USER_ID: 'participantId',
  SPLIT_USER_NAME: 'splitUserName',
  PARTICIPANT_ID: 'participantId',
} as const;

export type SplitBillsQueryParamKey =
  (typeof SPLIT_BILLS_QUERY_PARAMS)[keyof typeof SPLIT_BILLS_QUERY_PARAMS];

export const WEB_VIEW_MESSAGES = {
  OPEN_FRESH_CHAT: 'OPEN_FRESH_CHAT',
  OPEN_FRESH_CHAT_WITH_RESTORE_ID: 'OPEN_FRESH_CHAT_WITH_RESTORE_ID',
  OPEN_WALK_THROUGH_APP: 'OPEN_WALK_THROUGH_APP',
  OPEN_DEEP_LINK: 'OPEN_DEEP_LINK',
};

export const GO_LINK_HOST = 'https://modak.go.link';
export const GO_LINK_HOST_DEV = 'https://modak-development.go.link';

export const BASE_URL_WEB_APP_PROD = 'https://app.modakmakers.com';
export const BASE_URL_WEB_APP_DEV = 'https://app.dev.modakmakers.com';
export const GO_LINK_ADJ_T = '1g5vqahk_1g7pvrem';
export const ADJUST_QUERY_PARAMS = `adj_t=${GO_LINK_ADJ_T}`;

export const SPLIT_PUBLIC_URL_TEMPLATE = `${GO_LINK_HOST}/splits?split_id=:splitId&${ADJUST_QUERY_PARAMS}`;

export const SPLIT_ADD_SKIP_REASONS = {
  MISSING_SESSION_OR_SPLIT: 'missing-session-or-split',
  USER_NOT_LOGGED_IN: 'user-not-logged-in',
  NO_DEFAULT_PAYMENT_LINK: 'no-default-payment-link',
} as const;

export type SplitAddSkipReason =
  (typeof SPLIT_ADD_SKIP_REASONS)[keyof typeof SPLIT_ADD_SKIP_REASONS];
